import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapeTopSection: {
    width: "100%",
    height: "100%",
  },
  arrowIconCont: {
    color: "#FF0000",
    fontSize: "6px",
    alignItems: "space-between",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "15px",
    height: "15px",
    marginTop: "-5px",
  },
  landscapeArabTopSection3: {
    height: "474px",
    // width: "100%",
  },
  landscapeEngTopSection3: {
    height: "100%",
    width: "474px",
    transform: "rotate(-90deg)",
    marginLeft: "80px",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument11 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", color: "#FF0000", marginRight: "6px" }}>
          <View
            style={{ fontSize: "6px", marginTop: "-22px", marginLeft: "12px" }}
          >
            <Text style={Styles.pointingText}>Start of text</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "100%" }}>
          <View style={{ height: "474px" }}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}></View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
          <View style={[{ flexDirection: "row-reverse" }]}>
            <View style={Styles.landscapeArabTopSection3}>
              {engChunks[1]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "57px", marginLeft: "6px" }}></View>
        </View>
        <View
          style={{
            textAlign: "right",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              position: "absolute",
              left: "30px",
            }}
          >
            <View>
              <Text style={[Styles.pointingText, { marginTop: "-12px" }]}>
                بداية النص
              </Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={Styles.landscapeTopSection}>
            <View style={Styles.landscapeEngTopSection3}>
              <View>{arabicText(arabChunks[0])}</View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightcurvepdf_arrow.png"
                style={Styles.curveArrowIcon}
              ></Image>
            </View>
          </View>
          <View>
            <View
              style={[Styles.landscapeEngTopSection3, { marginLeft: "6px" }]}
            >
              <View>{arabicText(arabChunks[1])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
        <View
          style={{
            textAlign: "right",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              marginRight: "6px",
              alignItems: "flex-end",
              position: "absolute",
              left: "30px",
            }}
          >
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={Styles.landscapeTopSection}>
            <View
              style={[Styles.landscapeEngTopSection3, { marginLeft: "80px" }]}
            >
              <View>{arabicText(arabChunks[2])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
          <View>
            <View
              style={[Styles.landscapeEngTopSection3, { marginLeft: "6px" }]}
            >
              <View>{arabicText(arabChunks[3])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View
              style={{
                fontSize: "6px",
                color: "#FF0000",
                width: "40px",
                position: "absolute",
                top: "96%",
              }}
            >
              <Text style={[Styles.pointingText, { marginTop: "-13px" }]}>
                نهاية النص
              </Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              marginRight: "6px",
              alignItems: "flex-end",

              position: "absolute",
              left: "30px",
            }}
          >
            <View style={{ width: "40px" }}>
              <Text style={[Styles.pointingText, { marginTop: "-13px" }]}>
                Resumed text
              </Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={[{ flexDirection: "row-reverse" }]}>
            <View
              style={[Styles.landscapeArabTopSection3, { marginLeft: "80px" }]}
            >
              {engChunks[2]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
      </Page>

      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", color: "#FF0000", marginRight: "6px" }}>
          <Image
            src="/images/rightpdf_arrow.png"
            style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
          ></Image>
        </View>
        <View style={{ width: "100%" }}>
          <View style={{ height: "474px" }}>
            {engChunks[3]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px", color: "#FF0000" }}>
          <View style={{ fontSize: "6px", position: "absolute", top: "96%" }}>
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument11;
